import { render, staticRenderFns } from "./ModifyMarket.vue?vue&type=template&id=2196479e&scoped=true&"
import script from "./ModifyMarket.vue?vue&type=script&lang=ts&"
export * from "./ModifyMarket.vue?vue&type=script&lang=ts&"
import style0 from "./ModifyMarket.vue?vue&type=style&index=0&id=2196479e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2196479e",
  null
  
)

export default component.exports